import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
// Internal component for handling individual image loading
const ImageItem = ({ src, alt, index }) => {
    const [isLoading, setIsLoading] = useState(true);

    return (
        <div className="break-inside-avoid rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 group mb-6 relative bg-gray-100">
            {isLoading && (
                <div className="absolute inset-0 flex items-center justify-center min-h-[200px] z-10">
                    <Loader2 className="w-8 h-8 text-primary animate-spin" />
                </div>
            )}
            <img
                src={src}
                alt={alt}
                className={`w-full h-auto object-cover transform transition-all duration-700 ${isLoading ? 'opacity-0 scale-95' : 'opacity-100 scale-100 hover:scale-105'
                    }`}
                loading="lazy"
                onLoad={() => setIsLoading(false)}
            />
        </div>
    );
};

const Gallery = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [activeTab, setActiveTab] = useState('actual');

    const actualPhotos = [
        '/assets/photos/actual/IMG_0.jpg',
        '/assets/photos/actual/IMG_1.JPG',
        '/assets/photos/actual/IMG_2.JPG',
        '/assets/photos/actual/IMG_3.JPG',
        '/assets/photos/actual/IMG_4.JPG',
        '/assets/photos/actual/IMG_5.JPG',
        '/assets/photos/actual/IMG_6.JPG',
        '/assets/photos/actual/IMG_7.JPG',
        '/assets/photos/actual/IMG_8.JPG',
        '/assets/photos/actual/IMG_9.JPG',
        '/assets/photos/actual/IMG_10.JPG',
        '/assets/photos/actual/IMG_11.JPG',
        '/assets/photos/actual/IMG_12.JPG',
        '/assets/photos/actual/IMG_13.JPG',
        '/assets/photos/actual/IMG_14.JPG',
        '/assets/photos/actual/IMG_15.JPG',
        '/assets/photos/actual/IMG_16.JPG',
        '/assets/photos/actual/IMG_17.JPG',
        '/assets/photos/actual/IMG_18.JPG',
        '/assets/photos/actual/IMG_19.JPG',
        '/assets/photos/actual/IMG_20.JPG',
        '/assets/photos/actual/IMG_21.JPG',
        '/assets/photos/actual/IMG_22.JPG',
        '/assets/photos/actual/IMG_23.JPG',
        '/assets/photos/actual/IMG_24.JPG',
        '/assets/photos/actual/IMG_25.JPG',
        '/assets/photos/actual/IMG_26.JPG',
        '/assets/photos/actual/IMG_27.JPG',
        '/assets/photos/actual/IMG_28.JPG',
        '/assets/photos/actual/IMG_29.JPG',
        '/assets/photos/actual/IMG_30.JPG',
        '/assets/photos/actual/IMG_31.JPG',
    ];

    const elevationPhotos = [
        '/assets/photos/elevations/P_0.JPG',
        '/assets/photos/elevations/P_1.JPG',
        '/assets/photos/elevations/P_2.jpg',
        '/assets/photos/elevations/P_3.jpg',
        '/assets/photos/elevations/P_4.JPG',
        '/assets/photos/elevations/P_5.jpg',
        '/assets/photos/elevations/P_6.jpg',
        '/assets/photos/elevations/P_7.jpg',
        '/assets/photos/elevations/P_8.jpg',
        '/assets/photos/elevations/P_9.JPG',
        '/assets/photos/elevations/P_10.jpg',
        '/assets/photos/elevations/P_11.jpg',
        '/assets/photos/elevations/P_12.jpg',
        '/assets/photos/elevations/P_13.jpg',
        '/assets/photos/elevations/P_14.jpg',
        '/assets/photos/elevations/P_15.jpg',
        '/assets/photos/elevations/P_16.jpg',
        '/assets/photos/elevations/P_17.jpg',
        '/assets/photos/elevations/P_18.jpg',
        '/assets/photos/elevations/P_19.jpg',
        '/assets/photos/elevations/P_20.jpg',
        '/assets/photos/elevations/P_21.jpg',
        '/assets/photos/elevations/P_22.JPG',
        '/assets/photos/elevations/P_23.jpg',
        '/assets/photos/elevations/P_24.jpg',
        '/assets/photos/elevations/P_25.jpg',
        '/assets/photos/elevations/P_26.jpg',
        '/assets/photos/elevations/P_27.JPG',
        '/assets/photos/elevations/P_28.JPG',
    ];

    const displayPhotos = activeTab === 'actual' ? actualPhotos : elevationPhotos;

    return (
        <div className="min-h-screen bg-white py-12">
            <div className="container mx-auto px-4">
                {/* Header */}
                <div className="text-center mb-12">
                    <h1 className="text-4xl font-bold text-gray-800 mb-4">Construction Gallery</h1>
                    <div className="w-20 h-1 bg-primary mx-auto"></div>
                    <p className="mt-4 text-gray-600 max-w-2xl mx-auto">
                        A glimpse into our world of construction. Witness the quality and precision in every detail.
                    </p>
                </div>

                {/* Tabs */}
                <div className="flex justify-center mb-10">
                    <div className="inline-flex bg-gray-100 p-1 rounded-lg">
                        <button
                            onClick={() => setActiveTab('actual')}
                            className={`px-6 py-2 rounded-md text-sm font-semibold transition-all duration-300 ${activeTab === 'actual'
                                ? 'bg-white text-primary shadow-sm'
                                : 'text-gray-600 hover:text-gray-900'
                                }`}
                        >
                            Actual Photos
                        </button>
                        <button
                            onClick={() => setActiveTab('elevations')}
                            className={`px-6 py-2 rounded-md text-sm font-semibold transition-all duration-300 ${activeTab === 'elevations'
                                ? 'bg-white text-primary shadow-sm'
                                : 'text-gray-600 hover:text-gray-900'
                                }`}
                        >
                            Design Elevations
                        </button>
                    </div>
                </div>

                {/* Grid */}
                <div className="columns-1 md:columns-2 lg:columns-3 gap-6">
                    {displayPhotos.map((photo, index) => (
                        <ImageItem
                            key={`${activeTab}-${index}`}
                            src={photo}
                            alt={`Construction ${activeTab} ${index + 1}`}
                            index={index}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Gallery;
